
import {ExplorerApi, RpcApi} from "atomicassets"
const AtomicAssetsAPI = new ExplorerApi("https://wax.api.atomicassets.io", "atomicassets", {fetch});

export default AtomicAssetsAPI;